<template>
  <div class="modal-input-phone-wrapper position-relative">
    <div class="close-btn-wrap">
      <div class="close-btn-modal" @click="$store.dispatch('closeModal')">
        <img src="../../../assets/images/icons/close.svg" />
      </div>
    </div>
    <form class="form-phone-verify" @submit.prevent="formSubmit">
      <div style="text-align: center;">
        <h1 style="padding-bottom: 18px;">
          {{ $t('web_modal_update_mail', 'Update Email') }}
        </h1>
        <p v-if="!isSso">
          {{
            $t(
              'web_first_msg_modal_mail',
              'Please verify your password and enter your new email'
            )
          }}
        </p>
        <p v-else>
          {{
            $t(
              'web_second_msg_modal_mail',
              'Please verify and enter your new email'
            )
          }}
        </p>
      </div>

      <div
        v-if="!codeSent"
        class="form-group position-relative pb-3 hera-input-phone"
      >
        <div>
          <InputPassword
            v-if="!isSso"
            v-model.trim="password"
            v-validate="'required|min:8|max:64'"
            style="margin-bottom: 10px;"
            :placeholder="$t('_web_password_placeholder', 'Password')"
            :name="$t('_web_password_placeholder', 'Password')"
            :tabindex="0"
            required
            :label="$t('_web_verify_password', 'Enter password')"
          />
        </div>
        <InputEmail
          v-model.trim="inputValue"
          v-focus
          v-validate="'required|email|max:128'"
          :name="$$t('Email', 'email-label')"
          type="email"
          :label="$$t('Email', 'email-label')"
          :tabindex="1"
          :placeholder="$t('_web_email_placeholder', 'your@email.com')"
          class="mt-4"
          autofocus
        />
        <div
          v-if="error"
          class="input-group-append hera-input-phone_icon-error"
        >
          <span class="input-group-text input-bg-gray border-0 text-danger">
            <AppIcon name="danger" />
          </span>
        </div>
        <!-- </div> -->
        <span
          v-show="error"
          :id="`phoneHelp_${id}`"
          class="form-text text-danger error-help"
        >
          {{ error }}
        </span>
        <invisible-recaptcha
          class="text-truncate new-signup-btn mt-6"
          :disabled="!inputValue"
          :sitekey="recaptchaKey"
          :validate="() => formSubmit"
          :callback="formSubmit"
          :loading="isLoading"
          >{{ $t('_web_mobile-num', 'Submit') }}
        </invisible-recaptcha>
        <p v-if="passwordError" class="warning">{{ passwordError }}</p>
      </div>

      <div v-else>
        <VerifyCode
          :emit-success="() => $emit('success')"
          :token-to-send="tokenToSend"
          :email="inputValue"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { translate } from '@/mixins/translate';
// import isLoading from '@/mixins/isLoading.js';
import { uniqueId, uniqBy } from '@/utils/lodashUtils';
import DefaultFlag from '@/assets/images/flags/ar.png';
import InputPassword from '@/components/form/InputPassword';
import AppIcon from '@/components/atoms/Icon';
import { RECAPTCHA_KEY } from '@/api/config';
import InvisibleRecaptcha from 'vue-invisible-recaptcha';
import VerifyCode from '@/views/auth/VerifyCodeEmail.vue';
import InputEmail from '@/components/form/InputEmail';

import { prop } from '@/utils/factories';

const DEFAULT_COUNTRY = {
  name: 'Saudi Arabia',
  calling_code: '966',
  logo: DefaultFlag,
};

export default {
  components: {
    VerifyCode,
    InputPassword,
    AppIcon,
    InputEmail,
    'invisible-recaptcha': InvisibleRecaptcha,
  },
  mixins: [translate('_web_signup')],
  $_veeValidate: {
    value() {
      return this.value;
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: prop(String),
    name: prop(String),
    label: prop(String, 'Email'),
    error: prop(String),
    inputAutofocus: prop(Boolean),
    inputProps: {
      type: Object,
      default: () => ({}),
    },
    savingKey: prop(String),
    isSso: prop(Boolean, false),
  },
  data() {
    return {
      id: uniqueId('input_phone_'),
      selectedCountry: DEFAULT_COUNTRY,
      recaptchaKey: RECAPTCHA_KEY,
      inputValue: '',
      popoverPosition: null,
      filterValue: '',
      countiesReplaced: false,
      codeSent: false,
      password: '',
      tokenToSend: '',
      passwordError: '',
    };
  },
  computed: {
    ...mapGetters(['countries', 'currentRegion', 'isLoading']),
    countriesReplaced() {
      return uniqBy(
        this.countries.map(country => {
          return {
            ...country,
            nameInLowerCase: country.name.toLowerCase(),
          };
        }),
        'calling_code'
      );
    },
    countryListFiltered() {
      if (!this.filterValue.trim()) {
        return this.countriesReplaced;
      }

      const filterValue = this.filterValue.toLowerCase();
      return this.countriesReplaced.filter(
        country => country.nameInLowerCase.indexOf(filterValue) === 0
      );
    },
  },
  watch: {
    countries() {
      this.setSavedPhone();
    },
    inputValue() {
      this.emitInput();
    },
  },
  created() {
    if (
      this.currentRegion.id === 'japan' &&
      this.countries &&
      this.countries.length
    ) {
      this.selectedCountry = this.countries.find(
        county => county.name === 'Japan'
      );
    }
  },
  mounted() {
    this.$nextTick(this.setSavedPhone);
  },
  methods: {
    ...mapActions(['sendCode', 'closeModal', 'setCredentials']),
    togglePopover(e) {
      this.popoverPosition = this.popoverPosition ? null : e.currentTarget;
    },
    popoverSwitched(isVisible) {
      if (!isVisible) {
        this.popoverPosition = null;
      } else {
        this.$nextTick(this.$refs.countrySearch.focusIn);
      }
    },

    popoverSelectCountry(item) {
      this.filterValue = '';
      this.selectedCountry = { ...item };
      this.emitInput();
    },
    clearSavedPhone() {
      window.localStorage.removeItem(`phone_${this.savingKey || 'default'}`);
      this.inputValue = '';
    },
    savePhone() {
      window.localStorage.setObjectToItem(
        `phone_${this.savingKey || 'default'}`,
        {
          code: this.selectedCountry.calling_code,
          value: this.inputValue,
          country: this.selectedCountry,
        }
      );
    },
    emitInput() {
      this.$emit(
        'input',
        this.inputValue
          ? this.selectedCountry.calling_code +
              this.inputValue.replace(/^0+/, '')
          : null
      );
    },
    formSubmit(token) {
      const captcha_response = token;

      this.setCredentials({
        source: this.isSso ? 'sso' : 'identity',
        password: this.isSso ? '' : this.password,
      })
        .then(res =>
          this.sendCode(
            {
              providedToken: res.temporary_token,
              email: this.inputValue,
              captcha_response,
            },
            (this.tokenToSend = res.temporary_token)
          )
            .then(() => {
              this.codeSent = true;
            })
            .catch(err => {
              this.passwordError = 'Email already in use';
              console.log('tu sammmm:', err.message);
            })
        )
        .catch(() => {
          this.passwordError = this.isSso
            ? 'Please provide correct Email'
            : 'Please provide correct password and your Email';
        });
    },
    setSavedPhone() {
      if (!this.countries || !this.countries.length) {
        return;
      }

      const savedPhone = window.localStorage.getObjectFromItem(
        `phone_${this.savingKey || 'default'}`
      );

      if (!savedPhone) {
        return;
      }

      const selectedCountry = this.countries.find(
        county => county.calling_code === savedPhone.code
      );

      if (!selectedCountry) {
        return;
      }

      this.inputValue = savedPhone.value;
      this.selectedCountry = selectedCountry;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-input-phone-wrapper {
  flex-direction: column;
  max-width: 550px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  height: 100%;
  .hera-input-phone {
    .float-dropbox {
      @media (max-width: 767px) {
        flex-direction: column;
      }
      top: 140px !important;
      left: 30px !important;
    }
    label {
      margin-top: 20px;
    }
    &_input-group {
      border-radius: $ph-medium-radius;
      &:focus-within {
        box-shadow: 0 0 0 0.2rem rgba($ph-accent, 0.25);
        &.is-invalid {
          box-shadow: 0 0 0 0.2rem rgba($ph-error, 0.25);
        }
      }

      // replace bootstrap styles for .input-group (always LTR)
      > .form-control:last-child,
      > .input-group-append > .input-group-text {
        border: 1px solid !important;
        border-color: #49536f !important;
      }
      > .input-group-prepend > .btn {
        border: 1px solid !important;
        border-color: #49536f !important;
        height: auto;
      }
    }

    %replace-bootstrap-styles {
      line-height: 1.5rem !important;
      font-size: 1rem !important;
      border-width: 0;
      color: $ph-primary-text !important;
    }
    &_btn {
      background-color: $ph-input-bg !important;
      @include inject-pseudo('-extend', ':active', ':hover') {
        background-color: $ph-input-bg !important;
      }
      @include inject-pseudo {
        box-shadow: none !important;
      }
      @extend %replace-bootstrap-styles;
    }
    &_input {
      @include inject-pseudo('-extend', ':focus') {
        // fix for webkit
        box-shadow: inset 0 0 1px 1px $ph-input-bg !important;
      }
      @extend %replace-bootstrap-styles;
    }
    &_flag {
      display: inline-block;
      overflow: hidden;
      width: 1.5rem;
      height: 1.5rem;
      vertical-align: middle;
      margin-right: 0.75rem; // not rtl
      object-fit: contain;
      object-position: center;
      .dropbox-list & {
        @include auto-rtl(
          (
            margin-right: 0.75rem,
            margin-left: 0,
          )
        );
        + span {
          display: inline-block;
          width: 3.75rem;
        }
      }
    }
    .form-phone-verify {
      .form-group {
        label {
          font-family: Exo;
          font-size: 12px !important;
          font-style: normal;
          font-weight: 400;
        }
      }
    }

    .dropbox-list {
      .input-search .AppIcon {
        fill: $text-muted;
      }
      li > span {
        padding: 0.5rem 0.75rem;
      }
    }
  }
}
.close-btn-wrap {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
}
.close-btn-modal {
  font-size: 32px;
  line-height: 20px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #30374a;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.warning {
  color: red;
  margin-top: 10px;
}
</style>
<style lang="scss">
.ph-panel--rounded-new {
  border-radius: 10px !important;
}
</style>
